import styled from '@emotion/styled';
import React, { useState } from 'react';
import { connect } from 'react-redux';

import ContractorSearch from './contractorSearch';
import TextInput from '../../../shared/TextInput/index.jsx';
import { BackArrow } from '../../../shared/svgIcons.jsx';
import { incrementStep, decrementStep, setFormData } from '../../redux/actions';

const StepWrapper = styled.div`
  max-width: 23.125rem;
  width: 100%;
`;

const IntroMessage = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  color: #333333;
`;

const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
  text-transform: none;
`;

const NextButton = styled.button`
  background-color: #d40f7d;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-size: 18px;
  padding: 0.5rem;
  width: 100%;
  margin-top: 1.5rem;

  :disabled {
    background-color: #d8d8d8;
    cursor: default;
  }
`;

const BackWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  color: #333333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;

  h3 {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    text-transform: uppercase;
    font-family: 'OCRoboto';
  }
`;

const BackText = styled.p`
  margin-top: 0.5rem;
  padding-bottom: 1.5rem;
  text-align: center;
  font-size: 12px;
`;

const InputWrapper = styled.div`
  width: 100%;
  padding: 0.5em 0;
`;

const Subscript = styled.a`
  cursor: pointer;
  display: block;
  font-size: 14px;
  margin: 0;
  padding-top: 1.5rem;
  text-align: center;
  text-decoration: underline;
  width: 100%;
`;

const HomeownerStep8 = ({ incrementStep, decrementStep, setFormData, formData }) => {
  const [showManualEntry, setShowManualEntry] = useState(false);
  const validated = formData.installingContractor;
  const noContractor = () => {
    setFormData({ installingContractor: '', installingContractorData: null });
    incrementStep();
  };

  return (
    <StepWrapper>
      <BackWrapper
        data-track="form-back"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 9 - which contractor installed your roof"
        onClick={decrementStep}
      >
        <BackArrow width="21" height="12" />
        <h3>Back</h3>
        <BackText>How many total squares is the roof?</BackText>
      </BackWrapper>
      <IntroMessage>That’s great! Now,</IntroMessage>
      <Header>Which contractor installed your roof?</Header>
      <InputWrapper>
        {showManualEntry ? (
          <Subscript
            onClick={() => {
              setShowManualEntry(false);
            }}
          >
            Search Contractors
          </Subscript>
        ) : (
          <ContractorSearch />
        )}
      </InputWrapper>
      {showManualEntry ? (
        <InputWrapper>
          <p>Company / Contractor Name</p>
          <TextInput fieldKey="installingContractor" />
        </InputWrapper>
      ) : (
        <Subscript
          onClick={() => {
            setShowManualEntry(true);
          }}
        >
          My contractor is not listed
        </Subscript>
      )}
      <Subscript onClick={noContractor}>A contractor did not install my roof</Subscript>
      <NextButton
        data-track="form-advance"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 9 - which contractor installed your roof"
        onClick={incrementStep}
        disabled={!validated}
      >
        Next
      </NextButton>
    </StepWrapper>
  );
};

const mapStateToProps = state => ({
  formData: state.formData,
});

const mapDispatchToProps = dispatch => ({
  incrementStep: () => dispatch(incrementStep()),
  decrementStep: () => dispatch(decrementStep()),
  setFormData: hash => dispatch(setFormData(hash)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeownerStep8);
